import { takeLatest, takeEvery, all } from 'redux-saga/effects'

import { AddToWishlist, StoreSelector } from '@sainsburys-tech/bolt'

import { FETCH_ALTERNATIVES_REQUEST } from '../actionTypes/alternativesActionTypes'
import { FETCH_AV_ALTERNATIVES_REQUEST } from '../actionTypes/avAlternativesActionTypes'
import { FETCH_AVAILABILITY_REQUEST } from '../actionTypes/availabilityActionTypes'
import { FETCH_RESOURCE_REQUEST } from '../actionTypes/resourceActionTypes'
import { FETCH_CMS_MTO_REQUEST, FETCH_CMS_DELIVERY_REQUEST } from '../actionTypes/cmsActionTypes'
import { FETCH_SPECIAL_OFFERS_REQUEST } from '../actionTypes/specialOffersActionTypes'
import { FETCH_PRODUCT_STORE_REQUEST } from '../actionTypes/productStoreActionTypes'
import { FETCH_PRODUCT_CARE_REQUEST } from '../actionTypes/productCareActionTypes'
import { LOCALISE_FULFILMENT } from '../actionTypes/localiseFulfilmentActionTypes'
import { GET_ALTERNATIVE_STORE } from '../actionTypes/AlternativeStoreActionTypes'
import { FETCH_BV_QUESTION_ANSWER_REQUEST } from '../actionTypes/bazaarVoiceQuestionAnswerActionTypes'
import { FETCH_BV_REVIEW_REQUEST } from '../actionTypes/bazaarVoiceReviewActionTypes'
import POST_BV_FEEDBACK from '../actionTypes/bazaarVoiceFeedbackActionTypes'
import { FETCH_FEATURED_PRODUCTS_REQUEST } from '../actionTypes/featuredProductsActionTypes'
import { CALCULATE_BASKET_PRICE_REQUEST } from '../actionTypes/calculateBasketPriceActionTypes'
import { FETCH_SPECIAL_OFFERS_CREATOR_REQUEST } from '../actionTypes/specialOffersCreatorActionTypes'
import { FETCH_SHOP_COLLECTION_REQUEST } from '../actionTypes/shopCollectionActionTypes'
import { FETCH_ESSENTIAL_EXTRAS_REQUEST, FETCH_EXTRAS_DATA_REQUEST } from '../actionTypes/essentialExtrasActionTypes'

import { alternativesSaga } from './alternatives/alternatives.saga'
import { availabilitySaga } from './availability/availability.saga'
import { resourceSaga } from './resource/resource.saga'
import { cmsMtoSaga, cmsDeliverySaga } from './cms/cms.saga'
import { specialOffersSaga } from './specialOffers/specialOffers.saga'
import { productStoreSaga } from './productStore/productStore.saga'
import { productCareSaga } from './productStore/productCare.saga'
import { localiseFulfilmentSaga } from './storeLocator/localiseFulfilment.saga'
import { alternativeStoreSaga } from './storeLocator/alternativeStore.saga'
import { bazaarVoiceQuestionAnswerSaga } from './bazaarVoiceQuestionAnswer/bazaarVoiceQuestionAnswer.saga'
import { bazaarVoiceReviewSaga } from './bazaarVoiceReview/bazaarVoiceReview.saga'
import { bazaarVoiceFeedbackSaga } from './bazaarVoiceFeedback/bazaarVoiceFeedback.saga'
import { featuredProductsSaga } from './featuredProducts/featuredProducts.saga'
import { basketPriceSaga } from './basketPrice/basketPrice.saga'
import { specialOffersCreatorSaga } from './specialOffersCreator/specialOffersCreator.saga'
import { essentialExtrasSaga } from './essentialExtras/essentialExtras.saga'
import { essentialExtrasDataSaga } from './essentialExtras/essentialExtrasData.saga'

function* rootSaga() {
  yield takeEvery(
    [FETCH_ALTERNATIVES_REQUEST, FETCH_AV_ALTERNATIVES_REQUEST, FETCH_SHOP_COLLECTION_REQUEST],
    alternativesSaga
  )
  yield takeLatest(FETCH_AVAILABILITY_REQUEST, availabilitySaga)
  yield takeEvery(FETCH_RESOURCE_REQUEST, resourceSaga)
  yield takeLatest(FETCH_CMS_MTO_REQUEST, cmsMtoSaga)
  yield takeLatest(FETCH_CMS_DELIVERY_REQUEST, cmsDeliverySaga)
  yield takeLatest(FETCH_SPECIAL_OFFERS_REQUEST, specialOffersSaga)
  yield takeLatest(FETCH_PRODUCT_STORE_REQUEST, productStoreSaga)
  yield takeEvery(FETCH_PRODUCT_CARE_REQUEST, productCareSaga)
  yield takeLatest(LOCALISE_FULFILMENT, localiseFulfilmentSaga)
  yield takeLatest(GET_ALTERNATIVE_STORE, alternativeStoreSaga)
  yield takeLatest(FETCH_BV_QUESTION_ANSWER_REQUEST, bazaarVoiceQuestionAnswerSaga)
  yield takeLatest(FETCH_BV_REVIEW_REQUEST, bazaarVoiceReviewSaga)
  yield takeLatest(POST_BV_FEEDBACK, bazaarVoiceFeedbackSaga)
  yield takeLatest(FETCH_FEATURED_PRODUCTS_REQUEST, featuredProductsSaga)
  yield takeLatest(CALCULATE_BASKET_PRICE_REQUEST, basketPriceSaga)
  yield takeLatest(FETCH_SPECIAL_OFFERS_CREATOR_REQUEST, specialOffersCreatorSaga)
  yield takeLatest(FETCH_ESSENTIAL_EXTRAS_REQUEST, essentialExtrasSaga)
  yield takeLatest(FETCH_EXTRAS_DATA_REQUEST, essentialExtrasDataSaga)

  yield all([...AddToWishlist.sagas])
  yield all([...StoreSelector.sagas])
}

export default rootSaga
